import useSWR, { SWRConfiguration } from 'swr';

import { GetAllAsync } from '../../services/api';
import { KendoGridResult } from '../../types/KendoGridResult';
import { TimeZoneResponse } from '../../types/responses/timezone-response';

const TimeZoneEndpoint = `timezones`;

export const useGetTimezones = (options?: SWRConfiguration) => {
  const { data, error, isLoading } = useSWR<KendoGridResult<TimeZoneResponse>>(
    `${TimeZoneEndpoint}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    timezones: data?.data,
    isLoading,
    isError: error
  };
};
